import React from 'react'
import PropTypes from 'prop-types'
import { Body, Footer, Header, Root, TopContent } from './BrandLayout.styles'

/**
 * The BrandLayout's component.
 */
const BrandLayout = props => {
  const { children, featured, footer, header } = props

  return (
    <Root>
      {header && <Header>{header}</Header>}
      {featured && <TopContent>{featured}</TopContent>}
      <Body>{children}</Body>
      {footer && <Footer>{footer}</Footer>}
    </Root>
  )
}

BrandLayout.defaultProps = {
  featured: null,
  footer: null,
  header: null
}
BrandLayout.propTypes = {
  children: PropTypes.node.isRequired,
  featured: PropTypes.node,
  footer: PropTypes.node,
  header: PropTypes.node
}

export default BrandLayout
